import { createContext, useContext, type Context, type ReactNode } from 'react';
import { useGuideShell } from '../hooks/useGuideShell';

type GuideContextValue = ReturnType<typeof useGuideShell>;

/** Survive Vite HMR — new createContext() breaks Provider/consumer identity mid-session. */
const GuideContext: Context<GuideContextValue | null> =
  (import.meta.hot?.data.guideCtx as Context<GuideContextValue | null> | undefined) ??
  createContext<GuideContextValue | null>(null);
if (import.meta.hot) import.meta.hot.data.guideCtx = GuideContext;

export function GuideProvider({ children }: { children: ReactNode }) {
  const value = useGuideShell();
  return <GuideContext.Provider value={value}>{children}</GuideContext.Provider>;
}

export function useGuide(): GuideContextValue {
  const ctx = useContext(GuideContext);
  if (!ctx) throw new Error('useGuide must be used within GuideProvider');
  return ctx;
}
